module.exports = "/assets/53c8002111024c6bbb6e4d01caf1b60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4B.png
// module id = 2159
// module chunks = 0